"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_slick_1 = require("react-slick");
const dateFormat = require("dateformat");
const fluxible_router_1 = require("fluxible-router");
class Slider extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const posts = this.props.posts || [];
        const settings = {
            draggable: true,
            autoplay: true,
            autoplaySpeed: 7000,
            arrows: false,
            dots: true,
            fade: true,
            speed: 500,
            infinite: true,
            cssEase: 'ease-in-out',
            touchThreshold: 100,
        };
        return (React.createElement("section", { className: 'featured pi-featured_slider' },
            React.createElement("div", { className: 'featured-slider' },
                React.createElement(react_slick_1.default, Object.assign({ ref: (c) => (this.slider = c) }, settings), posts.map((post) => {
                    return (React.createElement("div", { key: post._id, className: 'item', style: { position: 'relative' } },
                        React.createElement("div", { className: 'post-media' },
                            React.createElement("div", { className: 'item-content' },
                                React.createElement("div", { className: 'cat' },
                                    React.createElement("ul", { className: 'post-categories' },
                                        React.createElement("li", null, post.categories.length > 0 ?
                                            React.createElement(fluxible_router_1.NavLink, { preserveScrollPosition: true, href: '/blog?category=' + post.categories[0].name }, post.categories[0].name)
                                            : null))),
                                React.createElement("h2", null,
                                    React.createElement(fluxible_router_1.NavLink, { href: '/post/' + post.slug }, post.title)),
                                React.createElement("span", { className: 'date' }, dateFormat(post.publishedDate, 'mmmm dS, yyyy'))),
                            React.createElement("div", { className: 'overlay-slider' }),
                            React.createElement("div", { className: 'image-wrap' },
                                React.createElement(fluxible_router_1.NavLink, { href: '/post/' + post.slug },
                                    React.createElement("div", { className: 'item-img', style: { backgroundImage: 'url("' + post.image.secure_url + '")' } }),
                                    React.createElement("img", { width: 1600, height: 1067, src: post.image.secure_url, className: 'attachment-620 size-620 wp-post-image', alt: '' }))))));
                })),
                React.createElement("div", { className: 'owl-carousel featured-slider' },
                    React.createElement("div", { className: 'owl-controls clickable' },
                        React.createElement("div", { className: 'owl-buttons' },
                            React.createElement("div", { onClick: (e) => this.slider.slickPrev(), className: 'owl-prev' },
                                React.createElement("i", { className: 'fa fa-angle-left' })),
                            React.createElement("div", { onClick: (e) => this.slider.slickNext(), className: 'owl-next' },
                                React.createElement("i", { className: 'fa fa-angle-right' }))))))));
    }
}
exports.default = Slider;
class SliderProps {
}
